import { createFileRoute } from '@tanstack/react-router';


export const Route = createFileRoute('/app/leads')({
  // Deep-link contract: ?status=new|open|closed presets the active tab (New is
  // the default when absent). Anything else falls back to New in the page.
  validateSearch: (search) => ({
    status: typeof search.status === 'string' ? search.status : undefined,
  }),
});
